interface AppUrls {
  accountApp: string;
  ticketApp: string;
  indexApp: string;
  spaceApp: string;
}

interface Config {
  development: AppUrls;
  production: AppUrls;
}

const config: Config = {
  development: {
    accountApp: 'https://account.blackadder.local:3001',
    ticketApp: 'https://ticket.blackadder.local:3002',
    indexApp: 'https://blackadder.local:3000',
    spaceApp: 'https://space.blackadder.local:3003'
  },
  production: {
    accountApp: 'https://account.blackadder.co.jp',
    ticketApp: 'https://tickets.blackadder.co.jp',
    indexApp: 'https://blackadder.co.jp',
    spaceApp: 'https://space.blackadder.co.jp'
  }
};

const getEnvironment = () => {
  // NODE_ENVがproductionの場合は本番環境、それ以外は開発環境
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
};

export const getAppUrl = (appName: keyof AppUrls): string => {
  const env = getEnvironment();
  return config[env][appName];
};

export default config;